var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimLinksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.61667 12.0917C6.1 11.9001 5.64166 11.5251 5.35 10.9917C4.68333 9.77506 5.09166 8.19174 6.275 7.4584L8.22499 6.25006C9.39999 5.51673 10.9167 5.91672 11.5833 7.12505C12.25 8.34172 11.8417 9.92507 10.6583 10.6584L10.4 10.8417",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.425 7.875C13.9417 8.06667 14.4 8.44165 14.6917 8.97498C15.3584 10.1916 14.95 11.775 13.7667 12.5083L11.8167 13.7166C10.6417 14.45 9.12501 14.05 8.45834 12.8417C7.79167 11.625 8.20001 10.0417 9.38334 9.30833L9.64169 9.125",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3333C14.6024 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6024 1.66663 10 1.66663C5.39763 1.66663 1.66667 5.39759 1.66667 9.99996C1.66667 14.6023 5.39763 18.3333 10 18.3333Z",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimLinksIcon);
export default __webpack_public_path__ + "static/media/claim-links-icon.d8b7b15bc43a884dc4fc59833b5c0fe1.svg";
export { ForwardRef as ReactComponent };